import * as helper from "../helpers/WebServicesHelper";
import * as AppConfig from "../../logic/GlobalAppConfig";
import * as GlobalConstants from "../../GlobalConstants";

const defaultTimeoutInMS = 20000;

export async function fetchAuthenticate(username, password, targetUri) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  let encodedUri = targetUri ? helper.encodeBosUri(targetUri) : "NULL";
  return await fetch(baseUrl + "/Authenticate", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      UserId: username,
      UserSecret: password,
      ClientId: clientId,
      ClientSecret: clientSecret,
      TargetUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(json => helper.checkDefaultErrorMessage(json, false))
    .then(json => {
      //console.log("Authenticate: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchAuthenticateExternal(providerId, externalToken, targetUri) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  let encodedUri = targetUri ? helper.encodeBosUri(targetUri) : "NULL";
  return await fetch(baseUrl + "/AuthenticateExternal", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      ExternalProviderId: providerId,
      ExternalUserId: "NULL",
      ExternalToken: externalToken,
      ClientId: clientId,
      ClientSecret: clientSecret,
      TargetUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(json => helper.checkDefaultErrorMessage(json, false))
    .then(json => {
      //console.log("AuthenticateExternal: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchLinkUsers(token, providerId, externalToken) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  return await fetch(baseUrl + "/LinkUsers", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      ExternalProviderId: providerId,
      ExternalToken: externalToken
    })
  })
    .then(helper.checkStatus)
    .then(res => res.text())
    .then(result => helper.checkDefaultErrorMessage(result, true))
    .then(result => {
      //console.log("LinkUsers: " + result);
      return result;
    });
}

export async function fetchOneTimeTokenAuthentication(oneTimeToken) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  return await fetch(baseUrl + "/OneTimeTokenAuthentication", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      OneTimeToken: oneTimeToken,
      ClientId: clientId,
      ClientSecret: clientSecret
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("OneTimeTokenAuthentication: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchRegisterNewUser(username, targetUri) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  let encodedUri = targetUri ? helper.encodeBosUri(targetUri) : "NULL";
  return await fetch(baseUrl + "/RegisterNewUser", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      LoginEmail: username,
      ClientId: clientId,
      ClientSecret: clientSecret,
      TargetUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("RegisterNewUser: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchEmailVerification(verifyToken) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  return await fetch(baseUrl + "/EmailVerification", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      VerificationToken: verifyToken
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("EmailVerification: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchRequestLoginMail(username, targetUri) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  let encodedUri = targetUri ? helper.encodeBosUri(targetUri) : "NULL";
  return await fetch(baseUrl + "/RequestLoginMail", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      LoginEmail: username,
      ClientId: clientId,
      ClientSecret: clientSecret,
      TargetUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.text())
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      //console.log("RequestLoginMail: " + result);
      return result;
    });
}

export async function fetchRequestOneTimeToken(token, targetUri) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let encodedUri = targetUri ? helper.encodeBosUri(targetUri) : "NULL";
  return await fetch(baseUrl + "/RequestOneTimeToken", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      TargetUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("RequestOneTimeToken: " + result);
      return json;
    });
}

export async function fetchResetPassword(username) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientId = AppConfig.getClientId();
  let clientSecret = AppConfig.getClientSecret();
  return await fetch(baseUrl + "/ResetPassword", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      LoginEmail: username,
      ClientId: clientId,
      ClientSecret: clientSecret
    })
  })
    .then(helper.checkStatus)
    .then(res => res.text())
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      //console.log("ResetPassword: " + result);
      return result;
    });
}

export async function fetchRegisterGlobalUser() {
  return "TBD!";
}

export async function fetchAuthorize(token, servingDataSegmentId, subjectDataSegmentId) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  return await fetch(baseUrl + "/Authorize", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthentication(token),
    body: JSON.stringify({
      RequestingGlobalDatasegmentId: null,
      ServingGlobalDatasegmentId: servingDataSegmentId,
      SubjectGlobalDatasegmentId: subjectDataSegmentId,
      RequestSignature: null
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(json => helper.checkDefaultErrorMessage(json, false))
    .then(json => {
      //console.log("Authorize: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchRegisterNewClient(newClientSecret, clientPublicKey) {
  let baseUrl = AppConfig.getBosIdentityServiceUrl();
  let clientTypeId = GlobalConstants.clientTypeId;
  let clientTypeSecret = GlobalConstants.clientTypeSecret;
  return await fetch(baseUrl + "/RegisterNewClient", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeaders(),
    body: JSON.stringify({
      ClientTypeId: clientTypeId,
      ClientTypeSecret: clientTypeSecret,
      NewClientSecret: newClientSecret,
      ClientPublicKey: clientPublicKey
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("RegisterNewClient: " + JSON.stringify(json));
      return json.newClientId;
    });
}
